import { render } from "./ImportBackupOffering.vue?vue&type=template&id=941f0ddc&scoped=true"
import script from "./ImportBackupOffering.vue?vue&type=script&lang=js"
export * from "./ImportBackupOffering.vue?vue&type=script&lang=js"

import "./ImportBackupOffering.vue?vue&type=style&index=0&id=941f0ddc&scoped=true&lang=less"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941f0ddc"]])

export default __exports__